import { Component, OnInit, OnDestroy, Inject, ViewChild } from "@angular/core";
import { HttpClient } from '@angular/common/http';
import { DefaultValuesService } from '../../../services/defaultvalues.service';
import { Utils } from '../../../utils/utils';
import { SaveService } from '../../../services/save.service';
import { Subscription } from "rxjs";
import { ContactToUnitFilterComponent } from "./contacttounit-filter.component";
import { ContactToUnitListComponent } from "./contacttounit-list.component";

@Component({
    selector: "contacttounit",
    templateUrl: './contacttounit.component.html',
    standalone: false
})

export class ContactToUnitComponent implements OnInit, OnDestroy {

    list: ContactToUnit[] = [];

    title = "ContactToUnit";
    showLocalFilter = false;

    subscriptionStage: any;
    subscriptionTenant: any;
    subscriptions: Subscription[] = [];

    @ViewChild(ContactToUnitListComponent, { static: true }) listComponent!: ContactToUnitListComponent;
    @ViewChild(ContactToUnitFilterComponent, { static: true }) filterComponent!: ContactToUnitFilterComponent;

    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string
        , public defaults: DefaultValuesService
        , private saveService: SaveService
    ) { }

    ngOnInit(): void {
        this.subscriptionStage = this.defaults.stageMessageChanges$.subscribe(() => {
            this.getFilteredContractsByTenant()
            this.listComponent.clonedList = {}
        });
        this.subscriptionTenant = this.defaults.tenantMessageChanges$.subscribe(() => {
            this.getFilteredContractsByTenant()
            this.listComponent.clonedList = {}
        });
        if (this.defaults.tenant)
            this.getFilteredContractsByTenant()
    }

    ngOnDestroy() {
        this.saveService.removeListener(this);
        this.subscriptionStage.unsubscribe();
        this.subscriptionTenant.unsubscribe();
        this.subscriptions.forEach(x => x.unsubscribe())
    }

    getFilteredContractsByTenant() {
        const filter: ContactToUnitFilter = {
            'UnitIds': this.filterComponent.unitIds,
            'CustomerIds': this.filterComponent.customerIds,
            'ContractNumbers': this.filterComponent.contractNumbers,
            'ContactIds': this.filterComponent.contactIds,
            'OnlyActiveContracts': this.filterComponent.onlyActiveContracts
        }
        Utils.httpGetContactToUnit(
            this.http
            , this.baseUrl
            , this.defaults.stage
            , filter
            , this
            , function (tthis: any, list: ContactToUnit[]) {
                tthis.list = list;
                tthis.listComponent.clonedList = {}
                tthis.listComponent.expandedElements = new Set();
                tthis.saveService.showSaveButton(false)
                if (filter.CustomerIds.length < 1 && filter.ContractNumbers.length < 1 && filter.UnitIds.length < 1)
                    tthis.showLocalFilter = false;
                else
                    tthis.showLocalFilter = true;
                tthis.subscriptions.pop();
            }
        );
    }
    onReload() {
        this.getFilteredContractsByTenant();
        this.listComponent.clonedList = {}
        this.saveService.showSaveButton(false)
    }
    downloadContacttounitFiltered() {
        const filter: ContactToUnitFilter = {
            'UnitIds': this.filterComponent.unitIds,
            'CustomerIds': this.filterComponent.customerIds,
            'ContractNumbers': this.filterComponent.contractNumbers,
            'ContactIds': this.filterComponent.contactIds,
            'OnlyActiveContracts': this.filterComponent.onlyActiveContracts
        }
        Utils.httpDownloadContactToUnit(
            this.http
            , this.baseUrl
            , this.defaults.stage
            , this.defaults.tenant
            , filter
            , this
            , null)
    }
}
